import {gql,TypedDocumentNode} from '@apollo/client';

type StageBase = {
    description: string,
    id: string,
    title: string,
}

export type NoActionStage = StageBase & {
    files?: undefined,
    rejectionMessage?: undefined,
    type: 'NO_ACTION',
    waitTime: number,
}

export type ApprovalStage = StageBase & {
    files?: undefined,
    rejectionMessage: string,
    type: 'APPROVAL',
    waitTime: number,
}

export type UploadStageFile = {title: string, type: 'pdf' | 'image', id?: string, stageId?: ''}

export type UploadStage = StageBase & {
    files: UploadStageFile[],
    rejectionMessage?: undefined,
    type: 'UPLOAD',
    waitTime?: undefined,
}

export type Stage = NoActionStage | ApprovalStage | UploadStage

export type ListStage = Stage & {
    lastUpdatedBy?: string,
    order: number,
    stageFiles?: {title: string, requiredFileType: 'pdf' | 'image'}[],
    updatedAt?: Date,
}

interface Result {
    getAllStages: ListStage[]
}

export const GET_STAGES: TypedDocumentNode<Result> = gql`
    query GetSTAGES {
        getAllStages {
            description
            id
            lastUpdatedBy
            order
            rejectionMessage
            title
            type
            updatedAt
            waitTime
            stageFiles {
                id
                requiredFileType
                stageId
                title
            }
        }
    }       
`
